import React from 'react';
import ReactDOM from 'react-dom';

import AutosizeInput from 'components/AutosizeInput.jsx';
import BoxBody from 'components/BoxBody.jsx';
import BoxHeader from 'components/BoxHeader.jsx';
import Button from 'components/Button.jsx';
import Chat from 'entities/Chat';
import ChatActions from 'chat/actions/ChatActions';
import ChatParticipantSearchMixin from 'components/mixins/ChatParticipantSearchMixin';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import CurrentUser from 'auth/CurrentUser';
import Dialog from 'components/Dialog.jsx';
import Glyph from 'components/Glyph.jsx';
import GroupInviteModal from 'groups/components/GroupInviteModal.jsx';
import KeyConstants from 'constants/KeyConstants';
import ModalTrigger from 'components/ModalTrigger.jsx';
import PotentialChatMembers from 'collections/PotentialChatMembers';
import ScrollableArea from 'components/ScrollableArea.jsx';
import ToastActions from 'actions/ToastActions';
import Token from 'components/Token.jsx';
import { Roles } from 'user/UserConstants';
import { mountModal } from 'lib/modal';

import ChatListSearchItem from './ChatListSearchItem.jsx';

import './styles/AddParticipantModal.scss';

const AddParticipantModal = React.createClass({
  propTypes: {
    chat: React.PropTypes.instanceOf(Chat).isRequired,
    onAddParticipants: React.PropTypes.func,
  },

  mixins: [
    ChatParticipantSearchMixin,
  ],

  statics: {
    prefetch: [
      function() {
        return ChatActions.promisePotentialChatMembers();
      },
    ],
  },

  getInitialState() {
    return {
      pickedMembers: new PotentialChatMembers(),
      max: this.props.chat.getMaximumMembers() - this.props.chat.getPresentMemberships().length,
    };
  },

  componentDidMount() {
    this.focusInput();
  },

  onSubmit() {
    const { pickedMembers } = this.state;

    ChatActions.addMembersToChat(this.props.chat, pickedMembers.map(p => p.id))
      .then(() => {
        const message = pickedMembers.length === 1 ?
          `${pickedMembers.first().getName()} has been added to the ${this.getChatTypeName()}` :
          `${pickedMembers.length} people have been added to the ${this.getChatTypeName()}`;

        ToastActions.showSuccessToast(message);
        this.props.onRequestHide();
        if (this.props.onAddParticipants) {
          this.props.onAddParticipants();
        }
      })
      .catch(e => console.error('ChatActions.addMembersToChat failed', e));
  },

  getChatTypeName() {
    return this.props.chat.isActivityType() ? 'activity' : 'conversation';
  },

  clearInput() {
    ReactDOM.findDOMNode(this.refs.memberSearch).value = '';
    this.refs.memberSearch.onChange();
    this.handleInputChange();
  },

  handleGroupSelect(group) {
    this.refs.groupSelectionDialog.hide();
    mountModal(<GroupInviteModal group={group} />, this);
  },

  handleInputKeyDown(event) {
    const code = event.keyCode;
    switch (code) {
      case KeyConstants.ENTER: {
        const searchItem = this.refs[`searchItem-${this.state.highlight}`];
        if (searchItem) {
          searchItem.click();
        }
        break;
      }
      case KeyConstants.UP:
      case KeyConstants.DOWN: {
        let { highlight } = this.state;
        if (code === KeyConstants.UP) {
          if (highlight >= 0) {
            highlight -= 1;
          } else {
            highlight = this.state.results.length - 1;
          }
        } else {
          if (highlight < this.state.results.length) {
            highlight += 1;
          } else {
            highlight = 0;
          }
        }
        this.setState({ highlight });

        if (highlight >= 0 && highlight < this.state.results.length) {
          const searchItemNode = ReactDOM.findDOMNode(this.refs[`searchItem-${highlight}`]);
          this.refs.scrollArea.scrollIntoView(searchItemNode);
          this._blockResultMouseOverWhileScrolling = true;
        }
        break;
      }
      case KeyConstants.BACKSPACE: {
        const memberSearch = ReactDOM.findDOMNode(this.refs.memberSearch);
        if (memberSearch.value.length !== 0) {
          return;
        }

        this.state.pickedMembers.pop();
        this.forceUpdate();
        break;
      }
      default: {
        return;
      }
    }
    event.preventDefault();
  },

  handleOnSelectItem(member) {
    if (!member.isEligible()) {
      this.memberNotEligible(member);
      return;
    } else if (this.hasBeenInitialySelected(member)) {
      return;
    }

    if (this.hasBeenPicked(member)) {
      this.unpickMember(member);
    } else {
      this.pickMember(member);
    }
  },

  hasBeenInitialySelected(member) {
    return this.props.chat.isPresentMember(member);
  },

  hasBeenPicked(member) {
    return !!this.state.pickedMembers.get(member.id);
  },

  pickMember(member) {
    this.state.pickedMembers.add(member);
    this.clearInput();
    this.focusInput();
    this.forceUpdate();
  },

  unpickMember(member) {
    this.state.pickedMembers.remove(member);
    this.forceUpdate();
  },

  renderCancel() {
    return (
      <Button
        className="AddParticipantModal-footer-button"
        onClick={this.props.onRequestHide}
        level="secondary"
        eventElementName="AddParticipantModal-footer-button">
        Cancel
      </Button>
    );
  },

  renderConfirmModal(members) {
    const text = members.length === 1 ?
      `Add 1 person to this ${this.getChatTypeName()}?` :
      `Add ${members.length} people to this ${this.getChatTypeName()}?`;

    return (
      <ConfirmDialog
        eventScreenName="AddParticipantModal"
        title={text}
        actionButtonText="Add"
        cancelButtonText="Cancel"
        onConfirm={this.onSubmit}
        subtext={`New participants can see all the messages in this ${this.getChatTypeName()}.`}
      />
    );
  },

  renderInput() {
    const placeholder = this.state.pickedMembers.length > 0 ?
      '' : 'Who do you want to add?';

    return (
      <div className="AddParticipantModal-input" onClick={this.focusInput} >
        <span className="AddParticipantModal-input-to">
          Add:
        </span>
        <span>
          {this.renderPickerMemberTokens()}
        </span>
        <AutosizeInput
          ref="memberSearch"
          className="AddParticipantModal-input-text AddParticipantModal-autoSizeInput"
          placeholder={placeholder}
          onChange={this.handleInputChange}
          onFocus={this.handleInputFocus}
          onKeyDown={this.handleInputKeyDown}
        />
      </div>
    );
  },

  renderMember(member, index) {
    return (
      <ChatListSearchItem
        ref={'searchItem-' + index}
        key={member.id}
        member={member}
        query={this.state.query}
        highlight={member.id === this.state.highlight}
        onSelect={this.handleOnSelectItem}
        selected={this.hasBeenPicked(member)}
        added={this.hasBeenInitialySelected(member)}
        onMouseOver={() => this.handleResultMouseOver(member.id)}
      />
    );
  },

  renderMembers() {
    if (this.state.pickedMembers.length > this.state.max) {
      return (
        <div className="AddParticipantModal-limitReached">
          <Glyph
            className="AddParticipantModal-limitGlyph"
            name="chat-close-bubble-fill"
            size="xxxlarge"
          />
          <div className="AddParticipantModal-limitTitle">
            Only {this.props.chat.getMaximumMembers()} people can participate in a conversation.
          </div>
        </div>
      );
    }

    if (this.state.results.length === 0) {
      let button;
      if (CurrentUser.getUser().getRole() === Roles.teacher) {
        button = (
          <ModalTrigger modal={this.renderGroupSelectionDialog()}>
            <Button
              className="AddParticipantModal-inviteButton"
              level="secondary"
              color="shamrock"
              size="small"
              eventElementName="AddParticipantModal-inviteButton">
              Add students and parents
            </Button>
          </ModalTrigger>
        );
      }

      return (
        <div className="AddParticipantModal-noResults">
          <div>0 people found</div>
          {button}
        </div>
      );
    }

    return (
      <div className="AddParticipantModal-list">
        <ScrollableArea
          ref="scrollArea"
          className="AddParticipantModal-list-scrollArea"
          onScroll={this.handleScroll}
          showShadows>
          {this.state.results.map(this.renderMember)}
        </ScrollableArea>
      </div>
    );
  },

  renderPickerMemberTokens() {
    return this.state.pickedMembers
      .map(member => {
        return (
          <Token
            onRemove={() => this.unpickMember(member)}
            key={member.id}>
            {member.getName()}
          </Token>
        );
      });
  },

  renderSubmit() {
    const disabled = (
      this.state.pickedMembers.length < 1 ||
      this.state.pickedMembers.length > this.state.max
    );

    const modal = this.renderConfirmModal(this.state.pickedMembers);

    return (
      <ModalTrigger modal={modal}>
        <Button
          className="AddParticipantModal-footer-button"
          disabled={disabled}
          eventElementName="AddParticipantModal-footer-button">
          Add
        </Button>
      </ModalTrigger>
    );
  },

  render() {
    return (
      <Dialog {...this.props} size="small" className="AddParticipantModal">
        <BoxBody full>
          <BoxHeader className="AddParticipantModal-header">
            <h2>
              Add people to the {this.getChatTypeName()}
            </h2>
          </BoxHeader>
          <div className="AddParticipantModal-members">
            {this.renderInput()}
            {this.renderMembers()}
          </div>
          <div className="AddParticipantModal-footer">
            {this.renderCancel()}
            {this.renderSubmit()}
          </div>
        </BoxBody>
      </Dialog>
    );
  },
});

export default AddParticipantModal;



// WEBPACK FOOTER //
// ./src/chat/components/AddParticipantModal.jsx